import { walletCore } from '@/config/wallet-core';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useWalletStore = defineStore('wallet', () => {
  const account = ref<any>(null);
  const isConnected = ref(false);
  const isConnecting = ref(false);
  const error = ref<string | null>(null);

  // Getters
  const wallets = computed(() => walletCore.wallets);
  const currentAccount = computed(() => account.value);

  // Actions
  async function connect(walletName: string) {
    try {
      isConnecting.value = true;
      error.value = null;
      await walletCore.connect(walletName);
      account.value = walletCore.account;
      isConnected.value = !!walletCore.account;
    } catch (err: any) {
      error.value = err.message || 'Failed to connect wallet';
      console.error('Wallet connection error:', err);
    } finally {
      isConnecting.value = false;
    }
  }

  function disconnect() {
    walletCore.disconnect();
    account.value = null;
    isConnected.value = false;
    error.value = null;
  }

  // Initialize wallet listener
  function initWalletListener() {
    walletCore
      .onAccountChange()
      .then(() => {
        account.value = walletCore.account;
        isConnected.value = !!walletCore.account;
      })
      .catch(err => {
        console.error('Error initializing wallet listener:', err);
      });
  }

  return {
    // State
    account,
    isConnected,
    isConnecting,
    error,

    // Getters
    wallets,
    currentAccount,

    // Actions
    connect,
    disconnect,
    initWalletListener,
  };
});
